import React from "react";
import { MapPin } from "lucide-react";
import { optimized } from "./img";
import { useContentValue } from "../../ContentContext";

export const Hero = () => {
    const hero = useContentValue("hero", {
        background: "https://customer-assets.emergentagent.com/job_local-strake/artifacts/04xg8dns_AA4AB2C3-1350-42DE-8CE1-207608A44A8F.PNG",
        title: "Strake",
        subtitle: "Gourmet Sandwiches",
        text: "& Loaded Fries / Tots",
        kicker: "Behind Treetz Cannabis",
    });
    return (
        <section
            data-testid="hero-section"
            className="relative h-[100vh] min-h-[680px] w-full overflow-hidden bg-[#0F0D0B] grain"
        >
            <img
                src={optimized(hero.background, { w: 1000, q: 75 })}
                alt="Strake Sandwich Co"
                className="absolute inset-0 w-full h-full object-cover"
                style={{
                    objectPosition: "72% 55%",
                    filter: "brightness(1.14) saturate(1.16) contrast(1.05)",
                }}
                loading="eager"
                fetchPriority="high"
                decoding="async"
            />

            <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(ellipse_at_72%_55%,rgba(255,196,140,0.16),transparent_55%)] mix-blend-screen" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#0F0D0B]/85 from-0% via-[#0F0D0B]/30 via-40% to-transparent to-68%" />
            <div className="absolute inset-0 bg-gradient-to-b from-[#0F0D0B]/30 via-transparent to-[#0F0D0B]/55" />

            <div className="relative z-10 pt-14 sm:pt-16 px-6 flex justify-center">
                <div className="font-brand text-[#F5F1E8] text-[88px] sm:text-[112px] uppercase leading-[0.85] tracking-[-0.01em] [text-shadow:_0_4px_28px_rgba(0,0,0,0.6),_inset_0_1px_0_rgba(255,255,255,0.08)] [-webkit-text-stroke:0.5px_rgba(0,0,0,0.15)] grain">
                    {hero.title || "Strake"}
                </div>
            </div>

            <div className="absolute bottom-0 left-0 right-0 z-10 px-6 pb-12 max-w-[88%] sm:max-w-[72%]">
                <h1 className="font-vintage text-[#F5F1E8] uppercase font-normal leading-[1.05] tracking-tight text-[22px] sm:text-[28px] [text-shadow:_0_2px_10px_rgba(0,0,0,0.6)]">
                    {hero.subtitle}
                    {hero.text && (
                        <>
                            <br />
                            <span className="text-[#E8A87C]">{hero.text}</span>
                        </>
                    )}
                </h1>

                <div className="mt-5 flex items-center gap-2 text-[#F5F1E8] font-body">
                    <MapPin size={11} className="flex-shrink-0 text-[#E8A87C]" strokeWidth={2} />
                    <span className="text-[9px] sm:text-[10px] uppercase tracking-[0.32em] font-bold [text-shadow:_0_1px_4px_rgba(0,0,0,0.7)]">
                        {hero.kicker}
                    </span>
                </div>
            </div>

            <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-b from-transparent via-[#1A1A1A]/30 to-[#EFE7DB] pointer-events-none z-[5]" />
        </section>
    );
};
